import React, { useEffect } from "react";

import { Image } from "semantic-ui-react";

import CheckInLayout from "./CheckInLayout";

import "./AppToday.css";

// ======================= Types =======================
type AppTodayProps = {
  onEvent?: (e: any) => void;
  patientData?: Record<string, any>;
  patientCurrentEncounter?: any;
};

// ======================= Constants =======================
const IMAGES = {
  iconSuccess: "/static/images/checkin/icon-success.png",
  iconPhoneHeart: "/static/images/checkin/icon-phone-heart.png",
};

// ======================= Component =======================
const AppToday = (props: AppTodayProps) => {
  const queueNumber = props.patientCurrentEncounter?.number;
  const waitingCount = props.patientCurrentEncounter?.phlebotomy_waiting_count;

  useEffect(() => {
    if (props.patientData?.id) {
      props.onEvent?.({
        message: "GetPatientCurrentEncounter",
        params: { patientId: props.patientData.id },
      });
    }
  }, [props.patientData?.id]);

  return (
    <CheckInLayout>
      <div className="apptoday-content">
        <div className="apptoday-success">
          <div className="apptoday-success-icon-bg">
            <Image src={IMAGES.iconSuccess} style={{ width: "4rem", height: "4rem" }} />
          </div>
          <div style={{ fontWeight: 700, fontSize: "2.5rem", color: "#5D8439" }}>
            ลงทะเบียนสำเร็จ
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <div className="apptoday-phone-icon-bg">
            <Image src={IMAGES.iconPhoneHeart} style={{ width: "2rem" }} />
          </div>
          <div style={{ color: "#787878", fontSize: "1.25rem" }}>
            --- ตรวจสอบหมายเลขรับบริการซ้ำ ผ่าน Line OA: MeHealth ที่เมนู QR code ผู้รับบริการ ---
          </div>
        </div>

        <div className="apptoday-queue-box">
          <div style={{ fontWeight: 500, fontSize: "2rem", color: "#A85B6F" }}>
            หมายเลขรับบริการ
          </div>
          <div className="apptoday-queue-number">{queueNumber || "-"}</div>
          <div className="apptoday-queue-ahead">จำนวนคิวก่อนหน้า: {waitingCount ?? "-"}</div>
          <div className="apptoday-queue-note">ติดตามคิวของคุณผ่านหมายเลขรับบริการบนหน้าจอคิว</div>
        </div>
      </div>
    </CheckInLayout>
  );
};

AppToday.displayName = "AppToday";

export default AppToday;
